import type { KanbanTaskCardHeaderProps } from './kanban-task-card-header.types.ts';
import styles from './kanban-task-card-header.module.scss';

export function KanbanTaskCardHeader({ children }: KanbanTaskCardHeaderProps) {
  return <div className={styles.header}>{children}</div>;
}
